import { Injectable } from '@angular/core'
import { Globals } from './../helpers'
import { HttpInterceptor } from './http-error.interceptor'
import { Response } from '@angular/http'
import { UploadInput } from 'ngx-uploader';

@Injectable()
export class RemoteConfigService {
  private baseUrl: string

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.baseUrl = globals.url + 'contents/remote-config';
  }

  public getUploadEvent() {
    const event: UploadInput = {
      url: this.baseUrl + 'sign-script',
      method: 'POST',
      type: 'uploadAll',
      headers: this.http.jwt()
    };

    return event;
  }

  public getFiles(contentId: string) {
    return this.http.get(`${this.baseUrl}/${contentId}/files`).map((response: Response) => response.json())
  }
  public getAppFile(contentId: string, filename: string) {
    return this.http.get(`${this.baseUrl}/${contentId}/files/${filename}`).map((response: Response) => response.json())
  }
  public editAppFile(contentId: string, filename: string, fileData: string) {
    return this.http.post(`${this.baseUrl}/${contentId}/files/${filename}`, { fileData }).map((response: Response) => response.json())
  }
  public signRemoteScript(contentId: string) {
    return this.http.post(`${this.baseUrl}/${contentId}`, { signRemoteScript: true }).map((response: Response) => response.json())
  }
}
